import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layoutChange/layout";
import { Button } from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { toast } from "react-toastify";

const AddCategory = ({ createDeleteCategory, history }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [categoryName, setCategoryName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);

const handleSubmit = async () => {
  if (!categoryName) {
    toast.error("Please enter category name");
    return;
  }

  setIsLoading(true);

  const data = { name: categoryName };

  const res = await createDeleteCategory(data);

  if (res?.data?.status_code === 200 || res?.data?.status === true) {
    toast.success(res.data.message || "Category created successfully!");
  } else {
    toast.error(res.data.message || "Failed to create category");
  }

  setIsLoading(false);

  setTimeout(() => history.push(`${baseUrl}/procurement/category-list`), 2000);
};


  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/procurement/category-list`);
  };

  return (
    <Layout title="Back to Category List" isLoading={isLoading} isGoback={true}>
      <Fragment>
        <div className="card">
          <div className="card-header">Add Category</div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <ConstantInput
                  label="Category Name"
                  type="text"
                  value={categoryName}
                  handleChange={(val) => setCategoryName(val)}
                  required
                  isStarRequired={true}
                />
              </div>

              <div className="col-md-12 mt-3">
                <Button onClick={handleSubmit}>Submit</Button>
              </div>
            </div>
          </div>
        </div>

        <ModalPop title="Success" show={isModal} handleModalHide={handleModalHide} keyboard>
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="success" />
            </div>
            <h5>Category Created Successfully!</h5>
          </div>
        </ModalPop>
      </Fragment>
    </Layout>
  );
};

export default AddCategory;
